import React from 'react';
import styles from './styles/NoResultsBoxStyles';
import { localize } from 'react-localize-redux';

const NoResultsBox = ({ translate }) => (

  <div style={styles.content}>
      <span>
        {translate('GLOBAL.noResults')  }
      </span>
    </div>
);

export default localize(NoResultsBox, 'locale');



// WEBPACK FOOTER //
// ./src/components/noResults/NoResultsBox.js